import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IListIndirectTaxCredentialsParams,
  IListIndirectTaxCredentialsResponse,
} from './types';

export function useIndirectTaxCredentials(
  params: IListIndirectTaxCredentialsParams | null,
  token?: string
) {
  const queryParams = params
    ? new URLSearchParams({
        corporationId: params.corporationId.toString(),
        ...(params.portalIds && { portalIds: params.portalIds.join(',') }),
        ...(params.extendPortalDetails !== undefined && {
          extendPortalDetails: params.extendPortalDetails.toString(),
        }),
        ...(params.includeInactive !== undefined && {
          includeInactive: params.includeInactive.toString(),
        }),
      }).toString()
    : '';

  const { data, mutate, error, isLoading } =
    useSWR<IListIndirectTaxCredentialsResponse>(
      params ? `new-sales-tax/credentials/list?${queryParams}` : null,
      SWRFetcher({ method: 'GET' }, token)
    );

  return {
    data: data?.credentials,
    count: data?.count,
    mutate,
    error,
    isLoading,
  };
}
